import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../hooks/context/authContext";
import { usePostRequest } from "../../../hooks/usePostRequest/usePostRequest";
import { useGetRequest } from "../../../hooks/useGetRequest/useGetRequest";
import GenericModal from "../../../components/modal/GenericModal";
import { FILE_FORMATS, GENERIC_SUCCESS_TOAST_MESSAGE } from "../../../constants/hardCodedConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadConvenioFenomenoElNino2026API, guardarConvenioFenomenoElNino2026API } from "../../../consumers/backendApisUrls";
import { mostrarMensajeDeErrorConToast, responseCode200, responseTieneModelState } from "../../../consumers/httpRequiestsUtils";
import { toast } from "react-toastify";
import InputUploadFile from "../../../components/modalComponents/InputUploadFile";
import { downloadFile } from "../../../consumers/backendConsumer";

const FirmaConvenioFenomenoElNino2026Modal = ({ showModal, idEmpleado, idEmpleadoFlujoActividad, manageSearch }) => {

    const { state } = useContext(AuthContext);
    const [executePostRequest] = usePostRequest();
    const [executeGetRequest] = useGetRequest();
    const [validation, setValidation] = useState({});
    const [guardando, setGuardando] = useState(false);
    const guardandoRef = useRef(false);
    const [documentoFirmado, setDocumentoFirmado] = useState({});
    const [firmaColaborador, setFirmaColaborador] = useState({});
    const KEYS_INIT = { FirmaFileViewModel: "FirmaFileViewModel" };

    const SECTION_NAME = "modalFirmaConvenioFenomenoElNino2026Modal";

    const [subiendoArchivo, setSubiendoArchivo] = useState(false);
    const [s3UploadFileResponse, setS3UploadFileResponse] = useState({});

    const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);

    const init = async function () {

    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (guardandoRef.current) return;
        if (!validaciones()) return;
        guardandoRef.current = true;
        setGuardando(true);
        const docFirmado = await validarDocumentoFirmado();

        if (!docFirmado) {
            mostrarMensajeDeErrorConToast("No se pudo generar el documento firmado. Intente nuevamente.");
            guardandoRef.current = false;
            setGuardando(false);
            return;
        }
        let payload = {
            IdEmpleado: idEmpleado,
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: docFirmado
        };
        const response = await executePostRequest(guardarConvenioFenomenoElNino2026API(), payload);
        if (responseCode200(response)) {
            showModal();
            toast.success((response?.data?.Message) ? response?.data?.Message : GENERIC_SUCCESS_TOAST_MESSAGE);
            guardandoRef.current = false;
            setGuardando(false);
            await manageSearch();
        } else if (responseTieneModelState(response)) {
            setValidation(response?.response?.data.ModelState);
            guardandoRef.current = false;
            setGuardando(false);
        } else {
            mostrarMensajeDeErrorConToast(response);
            guardandoRef.current = false;
            setGuardando(false);
        }
    };

    const validaciones = () => {
        // 1. Validar que al menos haya subido la firma (el origen)
        if (isEmptyObject(firmaColaborador) || !firmaColaborador.OriginalFileName) {
            mostrarMensajeDeErrorConToast("Debe subir su firma antes de guardar.");
            return false;
        }

        return true;
    }
    const validarDocumentoFirmado = async () => {
        if (isEmptyObject(documentoFirmado)) {
            const dataBody = await obtenerFormatoFirmado();
            return dataBody;
        }
        else
            return documentoFirmado;
    }
    const btnDownloadFormatoAFirmar = async (event) => {
        event.preventDefault();
        const dataBody = await obtenerFormatoFirmado();
        if (dataBody)
            downloadFile(state.token, dataBody?.Path, dataBody?.OriginalFileName);

    };

    const obtenerFormatoFirmado = async () => {
        const updatedFirmaColaborador = {
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: firmaColaborador
        };
        const response = await executePostRequest(downloadConvenioFenomenoElNino2026API(), updatedFirmaColaborador);
        if (responseCode200(response)) {
            setDocumentoFirmado(response.data.Body);
            return response.data.Body;
        } else {
            mostrarMensajeDeErrorConToast(response);
            setDocumentoFirmado({});
            return null;
        }
    }

    return (
        <>
            <GenericModal showModal={showModal} width={"890px"} titulo="Firmar carta convenio Fenómeno El Niño 2026">
                <div className="margin-modal-body">
                    <div>
                        <form className="black-color-important">
                            <div className="row custom-form-group-modal">
                                <div>
                                    <InputUploadFile
                                        label="Firmar"
                                        direction="column"
                                        textButton="Subir Firma"
                                        name={KEYS_INIT.FirmaFileViewModel}
                                        uploadFile={firmaColaborador}
                                        setUploadFile={setFirmaColaborador}
                                        isUploading={subiendoArchivo}
                                        setIsUploading={setSubiendoArchivo}
                                        sectionName={SECTION_NAME}
                                        showToastSuccess={true}
                                        validExtensions={FILE_FORMATS.ALLOWED_IMAGE_FORMATS} />
                                </div>
                            </div>

                            <div className="row custom-form-group-modal">
                                <u>
                                    <a className="text-link-appereance" href="#" onClick={(event) => btnDownloadFormatoAFirmar(event)}><FontAwesomeIcon icon='download' /> Previsualizar carta de convenio</a>
                                </u>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="modal-footer" style={{ 'display': 'flex', 'justifyContent': 'space-between' }}>
                    <div className="message font-gothan-light" style={{ 'alignSelf': 'flex-start' }}>
                        <strong>
                            <p>* Campos obligatorios</p>
                            <p>* El formato permitido es un archivo .jpg o .png.</p>
                            <p>* Esta firma servirá para generar la carta de convenio firmada.</p>
                            <p>* Luego de subir su firma previsualizar el documento para poder guardar.</p>
                        </strong>
                    </div>
                    <div className="button" style={{ 'alignSelf': 'flex-end' }}>
                        <button className="btn btn-primary generic-button-ficha" onClick={onSubmit} disabled={subiendoArchivo || guardando}>Guardar</button>
                    </div>
                </div>
            </GenericModal>
        </>
    );
}

export default FirmaConvenioFenomenoElNino2026Modal;
